export type SelectOption = {
  label: string;
  value: string;
  keywords?: string[];
};

export const UNIT_OPTIONS: SelectOption[] = [
  { value: "metric", label: "Metric (cm, mm)", keywords: ["centimetre"] },
  { value: "imperial", label: "Imperial (in, ft)", keywords: ["inch"] },
];

export const LOCALE_OPTIONS: SelectOption[] = [
  { value: "en-NZ", label: "English (New Zealand)" },
  { value: "en-AU", label: "English (Australia)" },
  { value: "en-US", label: "English (United States)" },
  { value: "en-GB", label: "English (United Kingdom)" },
  { value: "en-CA", label: "English (Canada)" },
  { value: "en-SG", label: "English (Singapore)" },
  { value: "de-DE", label: "German (Germany)", keywords: ["Deutsch"] },
  { value: "fr-FR", label: "French (France)", keywords: ["Francais"] },
  { value: "ja-JP", label: "Japanese (Japan)" },
  { value: "zh-CN", label: "Chinese (China)" },
];

export const TIMEZONE_OPTIONS: SelectOption[] = [
  {
    value: "Pacific/Auckland",
    label: "Pacific/Auckland",
    keywords: ["New Zealand"],
  },
  {
    value: "Pacific/Chatham",
    label: "Pacific/Chatham",
    keywords: ["New Zealand"],
  },
  { value: "Australia/Sydney", label: "Australia/Sydney" },
  { value: "Australia/Melbourne", label: "Australia/Melbourne" },
  { value: "Australia/Brisbane", label: "Australia/Brisbane" },
  { value: "Australia/Adelaide", label: "Australia/Adelaide" },
  { value: "Australia/Perth", label: "Australia/Perth" },
  { value: "Asia/Singapore", label: "Asia/Singapore" },
  { value: "Asia/Tokyo", label: "Asia/Tokyo" },
  { value: "Asia/Shanghai", label: "Asia/Shanghai" },
  { value: "Europe/London", label: "Europe/London" },
  { value: "Europe/Berlin", label: "Europe/Berlin" },
  { value: "Europe/Paris", label: "Europe/Paris" },
  { value: "America/New_York", label: "America/New_York" },
  { value: "America/Chicago", label: "America/Chicago" },
  { value: "America/Denver", label: "America/Denver" },
  { value: "America/Los_Angeles", label: "America/Los_Angeles" },
  { value: "America/Toronto", label: "America/Toronto" },
  { value: "UTC", label: "UTC" },
];

export function filterSelectOptions(
  options: SelectOption[],
  query: string,
): SelectOption[] {
  const normalized = query.trim().toLocaleLowerCase();
  if (!normalized) return options;

  return options.filter((option) =>
    [option.label, option.value, ...(option.keywords ?? [])]
      .join(" ")
      .toLocaleLowerCase()
      .includes(normalized),
  );
}
